var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0046 1.00864C14.7441 0.730517 14.3217 0.730517 14.0612 1.00864L7.99999 7.47944L1.93881 1.00865C1.67829 0.730518 1.2559 0.730518 0.995378 1.00865C0.734858 1.28677 0.734858 1.73771 0.995379 2.01583L7.52943 8.99146C7.78995 9.26958 8.21233 9.26958 8.47286 8.99146C8.48403 8.97953 8.49472 8.96728 8.50494 8.95474L15.0046 2.01583C15.2651 1.7377 15.2651 1.28677 15.0046 1.00864Z",
    fill: "#798EA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.55715fd30a81a6d78037e1e39e1363ae.svg";
export { ForwardRef as ReactComponent };